import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { get_backlog_insights, get_po_backlog_state } from '../../../redux/po_backlog/backlog.selector';
import { Box, Paper, Table, TableBody, TableContainer, TableHead, TableRow } from '@mui/material';
import StyledTableCell from '../../../common/components/Table/StyledTableCell';
import { handle_sample_status_filter_change } from '../../../redux/po_backlog/backlog.action';

const SampleStatusSummary = ({ enable_filtering = false, isSmall = false, title }) => {
  const backlog_object = useSelector(get_po_backlog_state);
  const backlog_insights = useSelector((state) => {
    return get_backlog_insights(state, title);
  });

  const [selected_filter, set_selected_filter] = useState("total_sample");
  const dispatch = useDispatch();
  useEffect(() => {
    if (enable_filtering) {
      dispatch(handle_sample_status_filter_change(selected_filter, backlog_object));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selected_filter]);

  const small_style = (() => {
    const style = {};
    if (isSmall) {
      style.fontSize = "12px !important";
      style.padding = "12px !important";
    }
    return {
      ...style
    };
  })();

  return (
    <Box className="">
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <StyledTableCell colSpan={2} align='center'>
                <p className=''>Sample Status Summary - {title === "CB" ? "In Process" : title === "FP" ? "FP Pack" : title}</p>
              </StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {
              Object.entries(backlog_insights?.sample_status || {}).map(([key, value], index) =>
                <TableRow key={`${key}-${index}-sample_status`}
                  className={`${enable_filtering ? "cursor-pointer" : ""}`}
                  onClick={() => {
                    if (enable_filtering) {
                      set_selected_filter(key);
                    }
                  }}>
                  <StyledTableCell
                    className={`uppercase text-xs`}
                    sx={{
                      fontWeight: enable_filtering && selected_filter === key ? "900" : "normal",
                      ...small_style,
                    }}
                  >{key.split("_").join(" ")}</StyledTableCell>
                  <StyledTableCell
                    className={`uppercase text-xs`}
                    sx={{
                      fontWeight: enable_filtering && selected_filter === key ? "900" : "normal",
                      ...small_style,
                    }}
                  >{value}</StyledTableCell>
                </TableRow>
              )
            }
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default SampleStatusSummary;